export default {
  CREATE_LINK_SOWOS_WEALTH_COMMAND: Symbol.for('CREATE_LINK_SOWOS_WEALTH_COMMAND'),
  CREATE_LINK_WEALTH_V2_COMMAND: Symbol.for('CREATE_LINK_WEALTH_V2_COMMAND'),
  LINK_SOWOS_WEALTH_REPOSITORY: Symbol.for('LINK_SOWOS_WEALTH_REPOSITORY'),
  LINK_GOALS_WEALTH_STATE_MANAGER: Symbol.for('LINK_GOALS_WEALTH_STATE_MANAGER'),
};
